import { API_AUTH } from "./common";

const TaiSanApi = {
  taiSanTheoChoVay: ({ chovayId }) =>
    API_AUTH.get(
      `quan-ly-tai-san/chi-tiet-theo-cho-vay?chovayId=${chovayId}`,
      {}
    ),
  taiSanTheoChoVay1: (chovayId) =>
    API_AUTH.get(
      `quan-ly-tai-san/chi-tiet-theo-cho-vay1?chovayId=${chovayId}`,
      {}
    ),
  getDetail: ({ taiSanId }) =>
    API_AUTH.get(`quan-ly-tai-san/chi-tiet?taisanId=${taiSanId}`, {}),
  getLichSuTaiSan: ({ taiSanId, pageSize, pageIndex }) =>
    API_AUTH.get(
      `quan-ly-tai-san/lich-su-tai-san?taisanId=${taiSanId}&pageSize=${pageSize}&pageIndex=${pageIndex}`,
      {}
    ),

  getLichSuTaiSan1: (taiSanId, pageSize, pageIndex) =>
    API_AUTH.get(
      `quan-ly-tai-san/lich-su-tai-san?taisanId=${taiSanId}&pageSize=${pageSize}&pageIndex=${pageIndex}`,
      {}
    ),
  taiSanTheoNhanVay1: (nhanvayID) =>
    API_AUTH.get(
      `quan-ly-tai-san/chi-tiet-theo-nhan-vay?nhanvayID=${nhanvayID}`,
      {}
    ),
  getTaiSan: (OrderID) =>
    API_AUTH.get(`QuanLyMuaBan/TaiSan/GetTaiSan?orderID=${OrderID}`),
  getThuocTinhChoTaiSan: (TaiSanID) =>
    API_AUTH.get(`QuanLyMuaBan/TaiSan/GetThuocTinhChoTaiSan?taiSanID=${TaiSanID}`),
};

export default TaiSanApi;
